import { getFetchedDataPayload } from '../../../../utils/fetched-data/get-fetched-data-payload';
import { temporaryBrowsingDomainStore } from '../../temporary-store/store';
export const getCxmFilmsForComponent = (componentId) => {
    const filmIdsForComponents = temporaryBrowsingDomainStore.data.cxmFilmsForComponent[componentId];
    return getFetchedDataPayload(filmIdsForComponents);
};
